const EDITABLE_INPUT_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export const isEditorModalOpen = () => {
  if (typeof document === 'undefined') {
    return false;
  }
  if (document.body.classList.contains('Modal-open')) {
    return true;
  }
  if (document.querySelector('.MuiDialog-root[aria-hidden="false"]')) {
    return true;
  }
  return Boolean(
    document.querySelector('.MuiBackdrop-root:not([aria-hidden="true"])'),
  );
};

const shouldIgnoreEditorKeyboardShortcut = (event) => {
  const { target } = event;
  if (!(target instanceof Element)) {
    return false;
  }
  if (EDITABLE_INPUT_TAGS.has(target.tagName)) {
    return true;
  }
  if (target.isContentEditable) {
    return true;
  }
  return Boolean(
    target.closest('textarea, input, select, [contenteditable="true"]'),
  );
};

export default shouldIgnoreEditorKeyboardShortcut;
